import { jsx, jsxs } from "react/jsx-runtime";
import { Suspense, useCallback, useEffect, useMemo, useState } from "react";
import { Flex } from "antd";
import LeagueApi from "./../../api/LeagueApi.js";
import Loader from "./../../components/loader/Loader.js";
import HeaderTabs from "./../../components/tabComponents/HeaderTabs.js";
import TabsTabItems from "./../../components/tabComponents/TabsTabItems.js";
import { withScrollToTop } from "./../../hoc";
import useTabItems from "./../../hook/useTabItems.js";
import { useParams, useSearchParams } from "react-router-dom";
import { EVENT_ACTIONS, track } from "./../../lib/gtag.js";
import { Components } from "./leagueContent/leagueContentService";
import LeagueHeader from "./leagueHeader/LeagueHeader";
const LeagueDetails = () => {
  const { id } = useParams();
  const [leagueDetails, setLeagueDetails] = useState(null);
  const [currentSeason, setCurrentSeason] = useState(null);
  const [loading, setLoading] = useState(true);
  const tabItems = useMemo(
    () => {
      var _a;
      return (_a = leagueDetails == null ? void 0 : leagueDetails.tabItems) != null ? _a : [];
    },
    [leagueDetails]
  );
  const {
    items,
    activeTabKey,
    activeTabData,
    tabsActiveTabId,
    setActiveTabKey,
    setTabsActiveTabId
  } = useTabItems({ tabItems });
  const getLeagueDetailsApi = LeagueApi.getLeagueDetails();
  const [searchParams, setSearchParams] = useSearchParams();
  const Component = useMemo(
    () => {
      var _a;
      return (_a = Components[activeTabKey]) != null ? _a : Loader;
    },
    [activeTabKey]
  );
  useEffect(() => {
    setCurrentSeason(null);
    id && getLeagueDetails(
      {
        id,
        seasonId: searchParams.get("s") || null
      },
      (currentSeason2) => setCurrentSeason(currentSeason2)
    );
    return () => {
      getLeagueDetailsApi.cancel();
    };
  }, [id, searchParams.get("s")]);
  const getLeagueDetails = async ({ id: id2, seasonId }, callback) => {
    setLoading(true);
    try {
      const response = await getLeagueDetailsApi.call({
        id: id2,
        seasonId
      });
      setLeagueDetails(response.data);
      callback == null ? void 0 : callback(
        seasonId ? response.data.seasons.find(
          (s) => s.id === +searchParams.get("s")
        ) : response.data.latestSeason
      );
    } catch (error) {
      console.error("Error fetching league details:", error);
    } finally {
      setLoading(false);
    }
  };
  const handleCurrentSeasonChange = useCallback(
    (currentSeason2) => {
      const next = new URLSearchParams();
      next.set("s", currentSeason2.id);
      setSearchParams(next);
    },
    [id]
  );
  const videoClickCallback = useCallback(() => {
    track(EVENT_ACTIONS.VIDEO_FROM_LEAGUE);
  }, []);
  return loading ? /* @__PURE__ */ jsx(Loader, {}) : /* @__PURE__ */ jsxs(
    Flex,
    {
      vertical: true,
      gap: 24,
      style: { position: "relative" },
      className: "league-details",
      children: [
        /* @__PURE__ */ jsx(
          LeagueHeader,
          {
            iconUrl: leagueDetails == null ? void 0 : leagueDetails.iconUrl,
            name: leagueDetails == null ? void 0 : leagueDetails.name,
            seasons: leagueDetails == null ? void 0 : leagueDetails.seasons,
            currentSeason,
            setCurrentSeason: handleCurrentSeasonChange,
            itemId: leagueDetails == null ? void 0 : leagueDetails.id,
            isFavorite: leagueDetails == null ? void 0 : leagueDetails.isFavorite,
            children: /* @__PURE__ */ jsx(
              HeaderTabs,
              {
                items,
                activeTabKey,
                setActiveTabKey
              }
            )
          }
        ),
        /* @__PURE__ */ jsxs(Flex, { vertical: true, gap: 16, children: [
          /* @__PURE__ */ jsx(
            TabsTabItems,
            {
              activeTabData,
              tabItemId: tabsActiveTabId,
              setTabsActiveTabId,
              radioStyleType: "secondary"
            }
          ),
          /* @__PURE__ */ jsx(Suspense, { fallback: /* @__PURE__ */ jsx(Loader, {}), children: /* @__PURE__ */ jsx(
            Component,
            {
              leagueId: id,
              data: activeTabData,
              tabItemId: tabsActiveTabId,
              seasonId: currentSeason == null ? void 0 : currentSeason.id,
              videoClickCallback
            }
          ) })
        ] })
      ]
    }
  );
};
var stdin_default = withScrollToTop(LeagueDetails);
export {
  stdin_default as default
};
